import { render, staticRenderFns } from "./Invigorate.vue?vue&type=template&id=835f4bcc&scoped=true&"
import script from "./Invigorate.vue?vue&type=script&lang=js&"
export * from "./Invigorate.vue?vue&type=script&lang=js&"
import style0 from "./Invigorate.vue?vue&type=style&index=0&id=835f4bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835f4bcc",
  null
  
)

export default component.exports